import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '@src/environments/environment';
import { ServicioSesion } from '@app/services/sesion/sesion.service';
import { RoutesUrl } from '@app/routes.enum';

// Endpoints donde un 401 es esperado/no debe disparar cerrarSesion (evita el loop
// login->contexts 401->cerrarSesion->logout 401->cerrarSesion->logout->...).
const ENDPOINTS_SIN_REDIRECT_401 = ['/solicitarCodigo', '/verificarCodigo', '/logout', '/auth/me'];

let cerrandoSesion = false;

/**
 * La sesión vive en una cookie httpOnly compartida entre subdominios, no en
 * localStorage. Para requests al API: quita cualquier header Authorization
 * armado a mano (ya no aplica) y manda la cookie con withCredentials.
 * Además, ante un 401 fuera del propio login/logout, cierra sesión y redirige.
 */
export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.url)) {
    return next(req);
  }

  const sesion = inject(ServicioSesion);
  const router = inject(Router);

  const reqConCredenciales = req.clone({
    headers: req.headers.delete('Authorization'),
    withCredentials: true,
  });

  return next(reqConCredenciales).pipe(
    catchError((error: unknown) => {
      const esEndpointExcluido = ENDPOINTS_SIN_REDIRECT_401.some(e => req.url.includes(e));

      if (error instanceof HttpErrorResponse && error.status === 401 && !esEndpointExcluido && !cerrandoSesion) {
        cerrandoSesion = true;
        sesion.cerrarSesion();
        router.navigate(['/' + RoutesUrl.LOGIN]).finally(() => { cerrandoSesion = false; });
      }
      return throwError(() => error);
    })
  );
};
